import { render } from "./PPromotionRules.vue?vue&type=template&id=4e48d3fc&scoped=true"
import script from "./PPromotionRules.vue?vue&type=script&lang=js"
export * from "./PPromotionRules.vue?vue&type=script&lang=js"

import "./PPromotionRules.vue?vue&type=style&index=0&id=4e48d3fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e48d3fc"]])

export default __exports__